/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  TossMaterialTree,
  ErrorInfo,
  TossMaterialFileList,
  PostTossMaterialCategoryUploadBody,
  BinaryFile,
  GetTossMaterialFileDownloadParams,
  TossMaterialList,
  PostTossMaterialAcquisitionStatusesBody
} from '.././model'


/**
 * 制作管理に紐づいたトス資料ツリーを取得して返す。

 * @summary トス資料ツリー取得
 */
export const getTossMaterialTree = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TossMaterialTree>> => {
    return axios.get(
      `/tossMaterials/${productionId}/tree`,options
    );
  }


export const getGetTossMaterialTreeQueryKey = (productionId: number,) => [`/tossMaterials/${productionId}/tree`];

    
export type GetTossMaterialTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getTossMaterialTree>>>
export type GetTossMaterialTreeQueryError = AxiosError<ErrorInfo>

export const useGetTossMaterialTree = <TData = Awaited<ReturnType<typeof getTossMaterialTree>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTossMaterialTree>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTossMaterialTreeQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTossMaterialTree>>> = ({ signal }) => getTossMaterialTree(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getTossMaterialTree>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * トス資料ファイルをアップロードする。

 * @summary トス資料用ファイルアップロード
 */
export const postTossMaterialCategoryUpload = (
    productionId: number,
    tossMaterialCategoryId: number,
    postTossMaterialCategoryUploadBody: PostTossMaterialCategoryUploadBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TossMaterialFileList>> => {const formData = new FormData();
if(postTossMaterialCategoryUploadBody['files[]'] !== undefined) {
 postTossMaterialCategoryUploadBody['files[]'].forEach(value => formData.append('files[]', value));
 }

    return axios.post(
      `/tossMaterials/${productionId}/categories/${tossMaterialCategoryId}/upload`,
      formData,options
    );
  }



    export type PostTossMaterialCategoryUploadMutationResult = NonNullable<Awaited<ReturnType<typeof postTossMaterialCategoryUpload>>>
    export type PostTossMaterialCategoryUploadMutationBody = PostTossMaterialCategoryUploadBody
    export type PostTossMaterialCategoryUploadMutationError = AxiosError<ErrorInfo>

    export const usePostTossMaterialCategoryUpload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTossMaterialCategoryUpload>>, TError,{productionId: number;tossMaterialCategoryId: number;data: PostTossMaterialCategoryUploadBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTossMaterialCategoryUpload>>, {productionId: number;tossMaterialCategoryId: number;data: PostTossMaterialCategoryUploadBody}> = (props) => {
          const {productionId,tossMaterialCategoryId,data} = props ?? {};

          return  postTossMaterialCategoryUpload(productionId,tossMaterialCategoryId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTossMaterialCategoryUpload>>, TError, {productionId: number;tossMaterialCategoryId: number;data: PostTossMaterialCategoryUploadBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * トス資料ファイルをダウンロードする。

 * @summary トス資料用ファイルダウンロード
 */
export const getTossMaterialFileDownload = (
    productionId: number,
    tossMaterialFileId: number,
    params?: GetTossMaterialFileDownloadParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/tossMaterials/${productionId}/files/${tossMaterialFileId}/download`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetTossMaterialFileDownloadQueryKey = (productionId: number,
    tossMaterialFileId: number,
    params?: GetTossMaterialFileDownloadParams,) => [`/tossMaterials/${productionId}/files/${tossMaterialFileId}/download`, ...(params ? [params]: [])];

    
export type GetTossMaterialFileDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getTossMaterialFileDownload>>>
export type GetTossMaterialFileDownloadQueryError = AxiosError<ErrorInfo>

export const useGetTossMaterialFileDownload = <TData = Awaited<ReturnType<typeof getTossMaterialFileDownload>>, TError = AxiosError<ErrorInfo>>(
 productionId: number,
    tossMaterialFileId: number,
    params?: GetTossMaterialFileDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTossMaterialFileDownload>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTossMaterialFileDownloadQueryKey(productionId,tossMaterialFileId,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTossMaterialFileDownload>>> = ({ signal }) => getTossMaterialFileDownload(productionId,tossMaterialFileId,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getTossMaterialFileDownload>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId && tossMaterialFileId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * トス資料カテゴリの編集ロック処理。  
トス資料カテゴリテーブルのレコードに編集ロックセッションID、開始日時、有効期限等を設定する。

 * @summary トス資料カテゴリ編集ロック
 */
export const postTossMaterialCategoryLock = (
    productionId: number,
    tossMaterialCategoryId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/tossMaterials/${productionId}/categories/${tossMaterialCategoryId}/lock`,undefined,options
    );
  }



    export type PostTossMaterialCategoryLockMutationResult = NonNullable<Awaited<ReturnType<typeof postTossMaterialCategoryLock>>>
    
    export type PostTossMaterialCategoryLockMutationError = AxiosError<ErrorInfo>

    export const usePostTossMaterialCategoryLock = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTossMaterialCategoryLock>>, TError,{productionId: number;tossMaterialCategoryId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTossMaterialCategoryLock>>, {productionId: number;tossMaterialCategoryId: number}> = (props) => {
          const {productionId,tossMaterialCategoryId} = props ?? {};

          return  postTossMaterialCategoryLock(productionId,tossMaterialCategoryId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTossMaterialCategoryLock>>, TError, {productionId: number;tossMaterialCategoryId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * トス資料カテゴリの編集をキャンセルし、編集ロックを解除する。

 * @summary トス資料カテゴリの編集キャンセル・ロック解除
 */
export const postTossMaterialCategoryCancel = (
    productionId: number,
    tossMaterialCategoryId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/tossMaterials/${productionId}/categories/${tossMaterialCategoryId}/cancel`,undefined,options
    );
  }



    export type PostTossMaterialCategoryCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postTossMaterialCategoryCancel>>>
    
    export type PostTossMaterialCategoryCancelMutationError = AxiosError<ErrorInfo>

    export const usePostTossMaterialCategoryCancel = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTossMaterialCategoryCancel>>, TError,{productionId: number;tossMaterialCategoryId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTossMaterialCategoryCancel>>, {productionId: number;tossMaterialCategoryId: number}> = (props) => {
          const {productionId,tossMaterialCategoryId} = props ?? {};

          return  postTossMaterialCategoryCancel(productionId,tossMaterialCategoryId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTossMaterialCategoryCancel>>, TError, {productionId: number;tossMaterialCategoryId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * カテゴリ内トス資料の一覧を取得して返す。

 * @summary カテゴリ内トス資料の一覧取得
 */
export const getTossMaterialCategory = (
    productionId: number,
    tossMaterialCategoryId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TossMaterialList>> => {
    return axios.get(
      `/tossMaterials/${productionId}/categories/${tossMaterialCategoryId}`,options
    );
  }


export const getGetTossMaterialCategoryQueryKey = (productionId: number,
    tossMaterialCategoryId: number,) => [`/tossMaterials/${productionId}/categories/${tossMaterialCategoryId}`];

    
export type GetTossMaterialCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getTossMaterialCategory>>>
export type GetTossMaterialCategoryQueryError = AxiosError<ErrorInfo>

export const useGetTossMaterialCategory = <TData = Awaited<ReturnType<typeof getTossMaterialCategory>>, TError = AxiosError<ErrorInfo>>(
 productionId: number,
    tossMaterialCategoryId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTossMaterialCategory>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTossMaterialCategoryQueryKey(productionId,tossMaterialCategoryId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTossMaterialCategory>>> = ({ signal }) => getTossMaterialCategory(productionId,tossMaterialCategoryId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getTossMaterialCategory>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId && tossMaterialCategoryId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * トス資料カテゴリの編集を保存し、編集ロックを解除する。

 * @summary トス資料カテゴリ保存・ロック解除
 */
export const postTossMaterialCategorySave = (
    productionId: number,
    tossMaterialCategoryId: number,
    tossMaterialList: TossMaterialList, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/tossMaterials/${productionId}/categories/${tossMaterialCategoryId}/save`,
      tossMaterialList,options
    );
  }



    export type PostTossMaterialCategorySaveMutationResult = NonNullable<Awaited<ReturnType<typeof postTossMaterialCategorySave>>>
    export type PostTossMaterialCategorySaveMutationBody = TossMaterialList
    export type PostTossMaterialCategorySaveMutationError = AxiosError<ErrorInfo>

    export const usePostTossMaterialCategorySave = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTossMaterialCategorySave>>, TError,{productionId: number;tossMaterialCategoryId: number;data: TossMaterialList}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTossMaterialCategorySave>>, {productionId: number;tossMaterialCategoryId: number;data: TossMaterialList}> = (props) => {
          const {productionId,tossMaterialCategoryId,data} = props ?? {};

          return  postTossMaterialCategorySave(productionId,tossMaterialCategoryId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTossMaterialCategorySave>>, TError, {productionId: number;tossMaterialCategoryId: number;data: TossMaterialList}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * トス資料ファイルを一括ダウンロードする。

 * @summary トス資料一括ダウンロード
 */
export const getTossMaterialCategoriesDownload = (
    productionId: number,
    tossMaterialCategoryId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/tossMaterials/${productionId}/categories/${tossMaterialCategoryId}/download`,options
    );
  }


export const getGetTossMaterialCategoriesDownloadQueryKey = (productionId: number,
    tossMaterialCategoryId: number,) => [`/tossMaterials/${productionId}/categories/${tossMaterialCategoryId}/download`];

    
export type GetTossMaterialCategoriesDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getTossMaterialCategoriesDownload>>>
export type GetTossMaterialCategoriesDownloadQueryError = AxiosError<ErrorInfo>

export const useGetTossMaterialCategoriesDownload = <TData = Awaited<ReturnType<typeof getTossMaterialCategoriesDownload>>, TError = AxiosError<ErrorInfo>>(
 productionId: number,
    tossMaterialCategoryId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTossMaterialCategoriesDownload>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTossMaterialCategoriesDownloadQueryKey(productionId,tossMaterialCategoryId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTossMaterialCategoriesDownload>>> = ({ signal }) => getTossMaterialCategoriesDownload(productionId,tossMaterialCategoryId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getTossMaterialCategoriesDownload>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId && tossMaterialCategoryId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * トス資料取得率状況を一括更新する。

 * @summary トス資料取得状況の一括更新
 */
export const postTossMaterialAcquisitionStatuses = (
    productionId: number,
    postTossMaterialAcquisitionStatusesBody: PostTossMaterialAcquisitionStatusesBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/tossMaterials/${productionId}/acquisitionStatuses`,
      postTossMaterialAcquisitionStatusesBody,options
    );
  }



    export type PostTossMaterialAcquisitionStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof postTossMaterialAcquisitionStatuses>>>
    export type PostTossMaterialAcquisitionStatusesMutationBody = PostTossMaterialAcquisitionStatusesBody
    export type PostTossMaterialAcquisitionStatusesMutationError = AxiosError<ErrorInfo>

    export const usePostTossMaterialAcquisitionStatuses = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTossMaterialAcquisitionStatuses>>, TError,{productionId: number;data: PostTossMaterialAcquisitionStatusesBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTossMaterialAcquisitionStatuses>>, {productionId: number;data: PostTossMaterialAcquisitionStatusesBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postTossMaterialAcquisitionStatuses(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTossMaterialAcquisitionStatuses>>, TError, {productionId: number;data: PostTossMaterialAcquisitionStatusesBody}, TContext>(mutationFn, mutationOptions)
    }
    